import brandPortalOrdersbrandOrderTokenOrderFulfilment from "@faire/web-api/routes/brand-portal/orders/brandOrderToken/order-fulfilment";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var DiscrepancyInPayoutTotalIA = function DiscrepancyInPayoutTotalIA(_ref) {
  var brandOrder = _ref.brandOrder;
  if (brandOrder) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "XAYTV2",
      defaultMessage: [{
        "type": 0,
        "value": "Avant de contacter notre équipe d'assistance, nous vous recommandons de vérifier votre paiement, en tenant compte des informations suivantes :"
      }]
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
      step: 1
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "meI9PQ",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Vérifiez votre paiement"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " : vous trouverez le calcul détaillé sur la "
      }, {
        "children": [{
          "type": 0,
          "value": "page des détails de la commande"
        }],
        "type": 8,
        "value": "OrderDetailLinkFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        },
        OrderDetailLinkFormatting: function OrderDetailLinkFormatting(chunks) {
          var _brandOrder$brand_ord, _brandOrder$brand_ord2;
          return orderDetailLinkFormatting(chunks, (_brandOrder$brand_ord = (_brandOrder$brand_ord2 = brandOrder.brand_order) === null || _brandOrder$brand_ord2 === void 0 ? void 0 : _brandOrder$brand_ord2.token) !== null && _brandOrder$brand_ord !== void 0 ? _brandOrder$brand_ord : "");
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(LiItem, {
      step: 2
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "/23Rwc",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Vérifiez les retours et les ajustements"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " : les retours, les ajustements des frais d'expédition ou les réductions promotionnelles peuvent avoir une incidence sur votre paiement. Les montants de chaque catégorie sont repris dans les détails de votre transaction. Si des articles sont signalés comme endommagés ou manquants, ils seront déduits du paiement pour la commande concernée."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(LiItem, {
      step: 3
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "d6yt+p",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Tenez compte des commissions"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " : le calcul des commissions est basé sur le sous-total de la commande."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(LiItem, {
      step: 4
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "lEvLnb",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Tenez compte des frais de traitement"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " : les frais de traitement des paiements auront une incidence sur le montant final du paiement. La structure des frais dépend de l'option de paiement que vous avez sélectionnée."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(LiItem, {
      step: 5
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "GgW3sY",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Contactez-nous"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " : si vous avez d'autres questions ou si le paiement reçu ne vous semble pas correct, n'hésitez pas à nous contacter."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })))));
  }
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "omcjTV",
    defaultMessage: [{
      "type": 0,
      "value": "Avant de contacter notre équipe d'assistance, nous vous recommandons de vérifier votre paiement, en tenant compte des informations suivantes :"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "IzZ4Mb",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Vérifiez votre paiement"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " : vous pouvez consulter le calcul détaillé pour une commande en particulier en vous rendant dans Commandes, puis en cliquant sur la page des détails de la commande. Faites défiler l'écran jusqu'à la section « Vous avez reçu un paiement ! » et sélectionnez Voir le récapitulatif des paiements. Vous y trouverez un décompte détaillé du paiement."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "SWyxt7",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Vérifiez les retours et les ajustements"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " : les retours, les ajustements des frais d'expédition ou les réductions promotionnelles peuvent avoir une incidence sur votre paiement. Les montants de chaque catégorie sont repris dans le récapitulatif de votre paiement. Si des articles sont signalés comme endommagés ou manquants, ils seront déduits du paiement pour la commande concernée."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "OGBrmv",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Tenez compte des commissions"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " : le calcul des commissions est basé sur le sous-total de la commande."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "mU015p",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Renseignez-vous sur les frais de traitement"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " : les frais de traitement des paiements auront une incidence sur le montant du paiement final. La structure des frais dépend de l'option de paiement que vous avez sélectionnée."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 5
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "xUp5Oe",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Contactez-nous"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " : si vous avez d'autres questions ou si le paiement reçu ne vous semble pas correct, n'hésitez pas à nous contacter."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))));
};
var orderDetailLinkFormatting = function orderDetailLinkFormatting(chunks, brandOrderToken) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrdersbrandOrderTokenOrderFulfilment(brandOrderToken, {
      sync: "true"
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};